import React, { Component } from 'react'
import IssuesModel from '../models/IssuesModel'
import AuthModel from '../models/AuthModel'
import Permissions from '../models/Permissions'
import moment from 'moment'
import { Row, Col, Button, Icon, Form, DatePicker, Radio, Select, Checkbox, Spin } from 'antd'

const Option = Select.Option
const RadioGroup = Radio.Group
const dateFormat = 'YYYY/MM/DD'

class PublicForm extends Component {

    constructor(props) {
        super(props)
        this.onChangeParam = this.onChangeParam.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.onReset = this.onReset.bind(this)

        // Init UI form state
        this.state = {
            ...this.props.params,
            loading: true,
            submittedby: ''
        }
        this.distritos = []
        this.concelhos = []
        this.freguesias = []
        this.praias = []
        this.entities = []
    }

    loadOptions() {
        this.loading()
        IssuesModel.getSearchFields((fields) => {
            this.distritos = fields.distritos
            this.concelhos = fields.concelhos
            this.freguesias = fields.freguesias
            this.praias = fields.praias
            this.entities = fields.entities
            this.loading(false)
        })
    }

    componentDidMount() {
        this.loadOptions()
    }

    loading(toggle = true) {
        var state = Object.assign({}, this.state)
        state.loading = toggle
        this.setState(state)
    }

    componentWillReceiveProps(nextProps) {
        var formData = {
            ...this.state,
            loading: nextProps.loading || false,
            sort_column: nextProps.sort && nextProps.sort.field ? nextProps.sort.field : '',
            sort_order: nextProps.sort && nextProps.sort.order ? nextProps.sort.order : ''
        }

        // Filter results for non admin logged user
        const role = Permissions.getUserRole();
        if (['superuser', 'apaadmin'].indexOf(role) === -1) {
            formData['submittedby'] = 'registered';
        }

        // Set filter
        this.setState(formData)
    }

    onChangeParam(field, value) {
        const formData = Object.assign({}, this.state)
        formData[field] = value

        if ((field === 'distrito') && !formData['distrito']) {
            formData['concelho'] = '';
            formData['freguesia'] = '';
        }
        if ((field === 'concelho') && !formData['concelho']) formData['freguesia'] = '';
        this.setState(formData)
    }

    onSubmit() {
        this.loading(true)
        const formData = Object.assign({}, this.state)
        this.props.search(formData)
    }

    onExport(format, mime) {
        this.loading(true)
        var url = IssuesModel.endpoint() + '/search/export/' + format + '?token=' + AuthModel.getAuthToken()
        Object.keys(this.state).map((k) => { return url += '&' + k + '=' + this.state[k] })
        IssuesModel.download(format, url, mime, () => {
            this.loading(false)
        })
    }

    onReset(e) {
        e.preventDefault()
        var formData = IssuesModel.dispenseSearchForm()
        formData['submittedby'] = ''
        this.setState(formData)
        this.props.reset();
    }

    noAccents(s) {
        var r = s.toLowerCase();
        r = r.replace(new RegExp("\\s", 'g'),"");
        r = r.replace(new RegExp("[àáâãäå]", 'g'),"a")
        r = r.replace(new RegExp("æ", 'g'),"ae")
        r = r.replace(new RegExp("ç", 'g'),"c")
        r = r.replace(new RegExp("[èéêë]", 'g'),"e")
        r = r.replace(new RegExp("[ìíîï]", 'g'),"i")
        r = r.replace(new RegExp("ñ", 'g'),"n")
        r = r.replace(new RegExp("[òóôõö]", 'g'),"o")
        r = r.replace(new RegExp("œ", 'g'),"oe")
        r = r.replace(new RegExp("[ùúûü]", 'g'),"u")
        r = r.replace(new RegExp("[ýÿ]", 'g'),"y")
        r = r.replace(new RegExp("\\W", 'g'),"")
        return r
    }

    render() {
        var concelhos = this.concelhos
        var freguesias = this.freguesias
        var praias = this.praias

        // Load logged user role to remove issue type filter
        const role = Permissions.getUserRole();

        // Filter options
        if (this.state.distrito) {
            concelhos = concelhos.filter((item) => item.distrito_cod === this.state.distrito)
            praias = praias.filter((item) => item.di === this.state.distrito)
        }
        if (this.state.concelho) {
            freguesias = freguesias.filter((item) => item.concelho_cod === this.state.concelho)
            praias = praias.filter((item) => item.dico === this.state.concelho)
        }
        return (
            <div>
                <Form onSubmit={this.onSubmit}>
                    <Row>
                        <Col xs={24} sm={6}></Col>
                        <Col xs={24} sm={14}>
                            <legend>Pesquisar</legend>
                        </Col>
                    </Row>

                    { (['superuser', 'apaadmin'].indexOf(role) > -1) && (
                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="submittedby" className="ant-form-item-required" title="Perfil de Utilizador">
                                    Tipo de Registo
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <Select value={''+this.state.submittedby}
                                    onChange={(v) => this.onChangeParam('submittedby', v)}>
                                    <Option key="0" value="">-- qualquer --</Option>
                                    <Option key="2" value="anonymous">Público</Option>
                                    <Option key="1" value="registered">Técnico</Option>
                                </Select>
                            </div>
                        </div>
                    )}

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="issue_date_start" className="ant-form-item-required" title="Data Inicial">
                                Data Anterior à Ocorrência
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-4" id="issueDateStartWrapper">
                            <DatePicker value={this.state.issue_date_start ? moment(this.state.issue_date_start, dateFormat) : null}
                                format={dateFormat}
                                disabled={!!this.state.data_ocorrencia_tipo}
                                onChange={(date, dateStr) => {this.onChangeParam('issue_date_start', dateStr)}}
                            />{' '}
                            <Checkbox
                                checked={!!this.state.data_ocorrencia_tipo}
                                onChange={(e) => this.onChangeParam('data_ocorrencia_tipo', e.target.checked ? 1 : 0)}
                                >
                                Indeterminada
                            </Checkbox>
                        </div>
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-4">
                            <label htmlFor="issue_date_end" className="ant-form-item-required" title="Data Final">
                                Data Posterior à Ocorrência
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-4" id="issueDateEndWrapper">
                            <DatePicker value={this.state.issue_date_end ? moment(this.state.issue_date_end, dateFormat) : null}
                                format={dateFormat}
                                disabled={!!this.state.data_ocorrencia_tipo}
                                onChange={(date, dateStr) => {this.onChangeParam('issue_date_end', dateStr)}}
                            />{' '}
                            <Checkbox
                                checked={!!this.state.data_ocorrencia_tipo}
                                onChange={(e) => this.onChangeParam('data_ocorrencia_tipo', e.target.checked ? 1 : 0)}
                                >
                                Indeterminada
                            </Checkbox>
                        </div>
                    </div>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="issue_local_date_start" className="ant-form-item-required" title="Data Inicial">
                                Data Anterior ao Registo
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-4">
                            <DatePicker value={this.state.issue_reg_local_start ? moment(this.state.issue_reg_local_start, dateFormat) : null}
                                format={dateFormat}
                                onChange={(date, dateStr) => {this.onChangeParam('issue_reg_local_start', dateStr)}}
                            />
                        </div>
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-4">
                            <label htmlFor="issue_local_date_end" className="ant-form-item-required" title="Data Final">
                                Data Posterior ao Registo
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-4">
                            <DatePicker value={this.state.issue_reg_local_end ? moment(this.state.issue_reg_local_end, dateFormat) : null}
                                format={dateFormat}
                                onChange={(date, dateStr) => {this.onChangeParam('issue_reg_local_end', dateStr)}}
                            />
                        </div>
                    </div>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="issue_date_start" className="ant-form-item-required" title="Data Inicial">
                                Data Anterior ao Registo no Sistema
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-4">
                            <DatePicker value={this.state.issue_reg_start ? moment(this.state.issue_reg_start, dateFormat) : null}
                                format={dateFormat}
                                onChange={(date, dateStr) => {this.onChangeParam('issue_reg_start', dateStr)}}
                            />
                        </div>
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-4">
                            <label htmlFor="issue_date_end" className="ant-form-item-required" title="Data Final">
                                Data Posterior ao Registo no Sistema
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-4">
                            <DatePicker value={this.state.issue_reg_end ? moment(this.state.issue_reg_end, dateFormat) : null}
                                format={dateFormat}
                                onChange={(date, dateStr) => {this.onChangeParam('issue_reg_end', dateStr)}}
                            />
                        </div>
                    </div>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="issuedetection" className="ant-form-item-required" title="Deteção da Ocorrência">
                                Deteção da Ocorrência
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14" id="issueDetectionWrapper">
                            <RadioGroup value={this.state.issue_detection}
                                onChange={(e) => {this.onChangeParam('issue_detection', e.target.value)}}>
                                <Radio value={0}>-- qualquer --</Radio>
                                <Radio value={1}>Aviso/Chamada</Radio>
                                <Radio value={2}>Visita Regular</Radio>
                            </RadioGroup>
                        </div>
                    </div>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="issuedetection" className="ant-form-item" title="Tipologia">
                                Tipologia
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14" style={{paddingTop: '7px'}}>
                            <Checkbox checked={this.state.tipo_a} onChange={(e) => {this.onChangeParam('tipo_a', e.target.checked)}}>
                                Instabilidade em arribas
                            </Checkbox>
                            <Checkbox checked={this.state.tipo_b} onChange={(e) => {this.onChangeParam('tipo_b', e.target.checked)}}>
                                Erosão/recuo da linha de costa
                            </Checkbox>
                            <Checkbox checked={this.state.tipo_c} onChange={(e) => {this.onChangeParam('tipo_c', e.target.checked)}}>
                                Dano em obra/estrutura de proteção costeira
                            </Checkbox>
                            <Checkbox checked={this.state.tipo_d} onChange={(e) => {this.onChangeParam('tipo_d', e.target.checked)}}>
                                Galgamento costeiro
                            </Checkbox>
                        </div>
                    </div>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="issuedetection" className="ant-form-item" title="Danos em infra-estuturas">
                                Danos em infra-estuturas
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14" style={{paddingTop: '7px'}}>
                            <Checkbox checked={this.state.cons_bii} onChange={(e) => {this.onChangeParam('cons_bii', e.target.checked)}}>
                                Estruturas de proteção/defesa costeira
                            </Checkbox>
                            <Checkbox checked={this.state.cons_biii} onChange={(e) => {this.onChangeParam('cons_biii', e.target.checked)}}>
                                Áreas construídas de fruição/uso público
                            </Checkbox>
                            <Checkbox checked={this.state.cons_biv} onChange={(e) => {this.onChangeParam('cons_biv', e.target.checked)}}>
                                Edificações
                            </Checkbox>
                        </div>
                    </div>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="issuedetection" className="ant-form-item-required" title="Pessoas em Risco">
                                Pessoas em Risco
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14" id="issueDetectionWrapper">
                            <RadioGroup value={this.state.cons_a}
                                onChange={(e) => {this.onChangeParam('cons_a', e.target.value)}}>
                                <Radio value={0}>-- qualquer --</Radio>
                                <Radio value={1}>Não</Radio>
                                <Radio value={2}>Não sabe/Não aplicável</Radio>
                                <Radio value={3}>Sim</Radio>
                            </RadioGroup>
                        </div>
                    </div>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="status" className="ant-form-item-required" title="Perfil de Utilizador">
                                Estado do Registo
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                            <Select value={''+this.state.status}
                                onChange={(v) => this.onChangeParam('status', v)}>
                                <Option key="0" value="">-- qualquer --</Option>
                                <Option key="1" value="Guardada">Guardada</Option>
                                <Option key="2" value="Submetida">Submetida</Option>
                            </Select>
                        </div>
                    </div>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="distrito" className="ant-form-item" title="Escolha o distrito">
                                Distrito
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                            <Select value={this.state.distrito} id="distrito"
                                showSearch
                                allowClear
                                placeholder="Escolha o distrito"
                                optionFilterProp="children"
                                onChange={(v) => this.onChangeParam('distrito', v)}>
                                { this.distritos.map((item) => (
                                    <Option key={''+item.di} value={''+item.di}>{item.distrito}</Option>
                                ) )}
                            </Select>
                        </div>
                    </div>

                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="concelho" className="ant-form-item" title="Escolha o concelho">
                                Concelho
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                            <Select value={this.state.concelho} id="concelho"
                                disabled={!this.state.distrito}
                                showSearch
                                allowClear
                                placeholder="Escolha o concelho"
                                optionFilterProp="children"
                                onChange={(v) => this.onChangeParam('concelho', v)}>
                                { concelhos.map((item) => (
                                    <Option key={''+item.dico} value={''+item.dico}>{item.concelho}</Option>
                                ) )}
                            </Select>
                        </div>
                    </div>
                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="freguesia" className="ant-form-item" title="Escolha a freguesia">
                                Freguesia
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                            <Select value={this.state.freguesia} id="freguesia"
                                disabled={!this.state.concelho}
                                showSearch
                                allowClear
                                placeholder="Escolha a freguesia"
                                optionFilterProp="children"
                                onChange={(v) => this.onChangeParam('freguesia', v)}>
                                { freguesias.map((item) => (
                                    <Option key={''+item.dicofre} value={''+item.dicofre}>{item.nome}</Option>
                                ) )}
                            </Select>
                        </div>
                    </div>


                    <div className="ant-row ant-form-item">
                        <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                            <label htmlFor="roles_id" className="ant-form-item" title="Escolha a praia">
                                Praia
                            </label>
                        </div>
                        <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                            <Select value={this.state.praia}
                                showSearch
                                allowClear
                                placeholder="Escolha a praia"
                                optionFilterProp="children"
                                filterOption={(input, option) => this.noAccents(option.props.children).indexOf(this.noAccents(input)) >= 0}
                                onChange={(v) => this.onChangeParam('praia', v)}>
                                { praias.map((item) => (
                                    <Option key={''+item.id} value={''+item.id}>{item.title}</Option>
                                ) )}
                            </Select>
                        </div>
                    </div>

                    <Row>
                        <Col xs={24} sm={6}></Col>
                        <Col xs={24} sm={14}>
                            { this.state.loading ? (<Spin />) : (
                              <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                  <Button style={{float: 'right'}} type="default" onClick={(e) => this.onExport('consulta.pdf', 'application/pdf')}>
                                      pdf
                                      <Icon type="file" />
                                  </Button>
                                  <Button style={{float: 'right'}} type="default" onClick={(e) => this.onExport('consulta.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')}>
                                      xlsx
                                      <Icon type="file" />
                                  </Button>
                                  <Button style={{float: 'right'}} type="default" onClick={(e) => this.onExport('consulta.zip', 'application/octet-stream')}>
                                      shp
                                      <Icon type="file" />
                                  </Button>

                                  <Button type="primary" onClick={(e) => this.onSubmit()}>
                                      Pesquisar
                                      <Icon type="search" />
                                  </Button>
                                  {' '}
                                  <Button type="danger" onClick={(e) => this.onReset(e)}>
                                      <span className="hide-small">Limpar</span>
                                      <i className="anticon anticon-close"></i>
                                  </Button>
                              </div>
                            ) }
                        </Col>
                    </Row>

                </Form>
            </div>
        )
    }
}

export default PublicForm;



// WEBPACK FOOTER //
// ./src/components/PublicSearchForm.js